'use strict';

/*@ngInject*/
module.exports = function($locationProvider) {
    $locationProvider.html5Mode(true);
};